import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import background from "../../../assets/images/bg-oauth.png";
import { showToast } from "../../../components/custom/custom-toast";
import { useFetchData } from "../../../hooks/useFetch";
import { MODULE_ROUTE } from "../../../routers/module-router";
import { API_OAUTH_ROUTER } from "../../../services/api-config";
import { ForgotPasswordComponent } from "../component/forgot-password-component";
import { NewPasswordComponent } from "../component/new-password-component";

export const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState("");
  const [username, setUserName] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [token, setToken] = useState("");
  const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
  const [invalidButton, setInvalidButton] = useState(true);

  const { request: onVerifyForgotPassword, baseResponse: responseVerifyForgot, loading: isLoadingVerify } = useFetchData.Post<any>();
  const { request: onForgotPassword, baseResponse: responsesForgotPassword, loading: isLoadingForgotPassword } = useFetchData.Post();


  useEffect(() => {
    setInvalidButton(companyName.length < 2 || username.length < 2 || otpCode.length < 6);
  }, [companyName, username, otpCode]);

  const handleSendOtpForgotPassword = () => {
    onVerifyForgotPassword({
      endPoint: API_OAUTH_ROUTER.VERIFY_OTP_FORGOT_PASSWORD,
      data: {
        identifier_name: companyName.toLocaleLowerCase(),
        username: username.toLocaleLowerCase(),
        otp: otpCode,
      },
    });
  };

  const handleChangeForgotPassword = (newPassword: string) => {
    onForgotPassword({
      endPoint: API_OAUTH_ROUTER.RESET_PASSWORD,
      data: {
        username: username.toLocaleLowerCase(),
        token: token,
        new_password: btoa(newPassword),
      },
    });
  };

  useEffect(() => {
    if (!responseVerifyForgot) { return }
    if (responseVerifyForgot.status === 200) {
      setShowNewPasswordForm(true);
      setToken(responseVerifyForgot.data.token);
    } else {
      showToast({ message: responseVerifyForgot.message, type: "warning" });
    }
  }, [responseVerifyForgot]);

  useEffect(() => {
    if (!responsesForgotPassword) { return }
    if (responsesForgotPassword.status === 200) {
      showToast({ message: "Cập nhật mật khẩu thành công", type: "success" });
      setTimeout(() => {
        navigate(MODULE_ROUTE.LOGIN, { replace: true });
      }, 1000);
    } else {
      showToast({ message: responsesForgotPassword.message, type: "warning" });
    }
  }, [responsesForgotPassword, navigate]);

  return (
    <div
      className="flex flex-col items-center justify-center h-screen px-6 py-8 mx-auto bg-center bg-no-repeat bg-cover lg:py-0"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          {(() => {
            if (showNewPasswordForm) {
              return (
                <NewPasswordComponent
                  requestNewPassword={handleChangeForgotPassword}
                  isLoading={isLoadingForgotPassword}
                />
              );
            } else {
              return (
                <ForgotPasswordComponent
                  setCompanyName={setCompanyName}
                  setUsernameForgotPassword={setUserName}
                  setValueOtp={setOtpCode}
                  toFormVerify={() => {
                    if (invalidButton) { return }
                    handleSendOtpForgotPassword()
                  }}
                  isLoading={isLoadingVerify}
                  isDisabled={invalidButton}
                />
              );
            }
          })()}
        </div>
      </div>
    </div>
  );
};
